<template>
  <div class="product-categories">

      <section class="product tigle" v-if="$route.params.product === this.$parent.products.tigle.nume.toLowerCase().split(' ').join('-')">
        <div class="product-banner">
          <!-- <img :src="this.$parent.products.tigle.img" :alt="this.$parent.products.tigle.titlu"> -->
        </div>
        <!-- END CATEGORY PRODUCT BANNER -->
        <div class="product-inner">
          <h2 class="product-title">{{ this.$parent.products.tigle.titlu }}</h2>
          <!-- END CATEGORY PRODUCT TITLE -->

          <div class="product-description" v-html="this.$parent.products.tigle.descriere"></div>
          <!-- END CATEGORY PRODUCT DESCRIPTION -->

          <h3>Alege modelul:</h3>
          <div class="row">
            <div class="col-sm-6">
              <div class="product-type">
                <div class="product-type__profile">
                  <img :src="this.$parent.products.tigle.tip.tabla_tip_tigla.img" :alt="this.$parent.products.tigle.tip.tabla_tip_tigla.nume">
                  <h5>{{ this.$parent.products.tigle.tip.tabla_tip_tigla.nume }}</h5>
                </div>
                <ul class="product-type__list">
                  <li v-for="product in this.$parent.products.tigle.tip.tabla_tip_tigla.produse" :key="product.id">
                    <div class="product-image">
                      <img :src="product.img" :alt="product.nume">
                      <h3>{{ product.nume }}</h3>
                      <div class="product-classes">
                        <span class="ruukki30" v-html="product.ruuki30"></span>
                        <span class="ruukki40" v-html="product.ruukki40"></span>
                        <span class="ruukki50" v-html="product.ruukki50plus"></span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- END PRODUCT TYPE TABLA -->
            <div class="col-sm-6">
              <div class="product-type">
                <div class="product-type__profile">
                  <img :src="this.$parent.products.tigle.tip.profile_prefaltuite.img" :alt="this.$parent.products.tigle.tip.profile_prefaltuite.nume">
                  <h5>{{ this.$parent.products.tigle.tip.profile_prefaltuite.nume }}</h5>
                </div>
                <ul class="product-type__list">
                  <li v-for="product in this.$parent.products.tigle.tip.profile_prefaltuite.produse" :key="product.id">
                    <div class="product-image">
                      <img :src="product.img" :alt="product.nume">
                      <h3>{{ product.nume }}</h3>
                      <div class="product-classes">
                        <span class="ruukki30" v-html="product.ruuki30"></span>
                        <span class="ruukki40" v-html="product.ruukki40"></span>
                        <span class="ruukki50" v-html="product.ruukki50plus"></span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- END PRODUCT TYPE PROFILE -->

          </div>
          <!-- END ROW -->


          <div class="product-guarantee">
            <h3 class="title">{{ this.$parent.products.tigle.garantie.titlu }}</h3>
            <p class="intro" v-html="this.$parent.products.tigle.garantie.intro"></p>
            <div class="greencoat" v-html="this.$parent.products.tigle.garantie.greencoat"></div>
            <div class="biotechnology" v-html="this.$parent.products.tigle.garantie.biotechnology"></div>
            <div v-html="this.$parent.products.tigle.garantie.biotechnology_list"></div>
            <p class="description" v-html="this.$parent.products.tigle.garantie.descriere"></p>
          </div>
          <!-- END PRODUCT GUARANTEE -->
        </div>

      </section>
      <!-- END SECTION PRODUCT TIGLE -->


      <section class="product profile" v-if="$route.params.product === this.$parent.products.profile.nume.toLowerCase().split(' ').join('-')">
        <div class="product-banner">
          <!-- <img :src="this.$parent.products.profile.img" :alt="this.$parent.products.profile.titlu"> -->
        </div>
        <!-- END CATEGORY PRODUCT BANNER -->
        <div class="product-inner">
          <h2 class="product-title">{{ this.$parent.products.profile.titlu }}</h2>
          <!-- END CATEGORY PRODUCT TITLE -->

          <div class="product-description" v-html="this.$parent.products.profile.descriere"></div>
          <!-- END CATEGORY PRODUCT DESCRIPTION -->

          <h3>Alege modelul:</h3>
              
          <ul class="profile-products-list">
            <li class="product" v-for="product in this.$parent.products.profile.produse" :key="product.id">
              <div class="product-image">
                <img :src="product.img" :alt="product.nume">
              </div>
              <h5 class="product-name">{{ product.nume }}</h5>
              <ul class="product-details">
                <li>{{ product.detalii.latime }}</li>
                <li>{{ product.detalii.inaltime }}</li>
                <li>{{ product.detalii.clase }}</li>
                <li>{{ product.detalii.utilitate }}</li>
              </ul>
            </li>
          </ul>
          <!-- END PRODUCTS PROFILE LIST -->
        </div>

      </section>
      <!-- END SECTION PRODUCT PROFILE -->


      <section class="product sisteme" v-if="$route.params.product === this.$parent.products.sistem.nume.toLowerCase().split(' ').join('-')">
        <div class="product-banner">
          <!-- <img :src="this.$parent.products.sistem.img" :alt="this.$parent.products.sistem.titlu"> -->
        </div>
        <!-- END CATEGORY PRODUCT BANNER -->

        <div class="product-inner">
           <h2 class="product-title">{{ this.$parent.products.sistem.titlu }}</h2>
          <!-- END CATEGORY PRODUCT TITLE -->

          <div class="product-description" v-html="this.$parent.products.sistem.descriere"></div>
          <!-- END CATEGORY PRODUCT DESCRIPTION -->

          <!-- <a class="is-link" :href="this.$parent.products.sistem.link.href">{{ this.$parent.products.sistem.nume }}</a> -->

          <h3>Referinte:</h3>

          <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.sistem.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
          </agile>
          <!-- END CATEGORY PRODUCT SLIDER -->

          <h3>Documente si brosuri:</h3>

          <ul class="product-documents">
            <li v-for="document in this.$parent.products.sistem.documente" :key="document.id">
              <a :href="document.href" :alt="document.nume" target="_blank">
                <div class="document-icon" v-html="document.icon"></div>
                <span class="document-date">{{ document.data }}</span>
                <h5 class="document-title">{{ document.nume }}</h5>
                <p class="document-size">{{ document.marime }}</p>
              </a>
            </li>
          </ul>
          <!-- END CATEGORY PRODUCT DOCUMENTS LIST -->
        </div>

      </section>
      <!-- END SECTION PRODUCT SISTEME -->


      <section class="product accesorii-siguranta" v-if="$route.params.product === this.$parent.products.accesorii_siguranta.nume.toLowerCase().split(' ').join('-')">
        <div class="product-banner">
          <!-- <img :src="this.$parent.products.accesorii_siguranta.img" :alt="this.$parent.products.accesorii_siguranta.titlu"> -->
        </div>
        <!-- END CATEGORY PRODUCT BANNER -->

        <div class="product-inner">
          <h2 class="product-title">{{ this.$parent.products.accesorii_siguranta.titlu }}</h2>
          <!-- END CATEGORY PRODUCT TITLE -->

          <div class="product-description" v-html="this.$parent.products.accesorii_siguranta.descriere"></div>
          <!-- END CATEGORY PRODUCT DESCRIPTION -->

          <!-- <a class="is-link" :href="this.$parent.products.accesorii_siguranta.link.href">{{ this.$parent.products.accesorii_siguranta.nume }}</a> -->

          <h3>Referinte:</h3>

          <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.accesorii_siguranta.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
          </agile>
          <!-- END CATEGORY PRODUCT CAROUSEL -->

          <h3>Documente si brosuri:</h3>

          <ul class="product-documents">
            <li v-for="document in this.$parent.products.accesorii_siguranta.documente" :key="document.id">
              <a :href="document.href" :alt="document.nume" target="_blank">
                <div class="document-icon" v-html="document.icon"></div>
                <h5 class="document-title">{{ document.nume }}</h5>
                <p class="document-size">{{ document.marime }}</p>
              </a>
            </li>
          </ul>
          <!-- END CATEGORY PRODUCT DOCUMENTS LIST -->
        </div>

      </section>
      <!-- END SECTION PRODUCT ACCESORII SIGURANTA -->


      <section class="product accesorii-metalice" v-if="$route.params.product === this.$parent.products.accesorii_metalice.nume.toLowerCase().split(' ').join('-')">
        <div class="product-banner">
          <!-- <img :src="this.$parent.products.accesorii_metalice.img" :alt="this.$parent.products.accesorii_metalice.titlu"> -->
        </div>
        <!-- END CATEGORY PRODUCT BANNER -->

        <div class="product-inner">
          <h2 class="product-title">{{ this.$parent.products.accesorii_metalice.titlu }}</h2>
          <!-- END CATEGORY PRODUCT TITLE -->

          <div class="product-description" v-html="this.$parent.products.accesorii_metalice.descriere"></div>
          <!-- END CATEGORY PRODUCT DESCRIPTION -->

        </div>

      </section>
      <!-- END SECTION PRODUCT ACCESORII METALICE -->

  </div>

</template>
<script>
export default {
  data() {
    return {
      name: "ruukkiProducts",
      options: {
        arrows: true,
        dots: true,
        speed: 750,
        fade: true,
        pauseOnHover: true,
        infinite: true,
        autoplay: true
      }
    };
  }
};
</script>
<style lang="scss">
@import "../../assets/css/_variables.scss";
.page-ruukki {
  .product-categories {
    > .product {
      background-color: $white;
      margin-bottom: 40px;
    }
  }
  .product {
    &-banner {
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      margin-bottom: 2rem;
      height: 300px;
    }
    &-inner {
      padding: 0 1rem 1rem 1rem;
    }
    &-description {
      margin-bottom: 1rem;
    }
    &-type {
      text-align: center;
      &__profile {
        display: inline-block;
        position: relative;
        margin-bottom: 1rem;
        h5 {
          background-color: rgba($white, 0.6);
          border: 2px solid $white;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0;
          position: absolute;
          top: 10px;
          right: 10px;
          bottom: 10px;
          left: 10px;
        }
      }
      &__list {
        li {
          margin-bottom: 1rem;
        }
        img {
          display: inline-block;
          width: auto;
        }
      }
    }
    &-guarantee {
      .greencoat {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        &-logo {
          margin-right: 1rem;
        }
        img {
          width: auto;
        }
        p {
          margin: 0;
        }
      }
      .biotechnology {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        &-logo {
          margin-left: 1rem;
        }
        img {
          width: auto;
        }
        p {
          margin: 0;
        }
      }
      ul {
        margin-bottom: 1rem;
        li {
          border-bottom: 1px solid $dark-gray;
          padding: 10px 0 10px 1rem;
          position: relative;
          &:last-child {
            border: 0;
          }
          &:before {
            content: "";
            background-color: $secondary-color;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -5px;
            height: 10px;
            width: 10px;
          }
        }
      }
      .is-link {
        margin-bottom: 1rem;
      }
    }
    &-documents {
      margin-bottom: 1rem;
      li:last-child {
        a {
          border: 0;
          margin: 0;
          padding: 0;
        }
      }
      a {
        border-bottom: 1px solid $dark-gray;
        display: block;
        margin-bottom: 10px;
        padding-bottom: 10px;
        &:hover {
          .document-title {
            color: $primary-color;
          }
        }
        .document {
          &-title {
            font-size: 1.125rem;
            margin: 10px 0;
            transition: color 300ms ease-in-out;
          }
          &-size {
            font-size: 0.875rem;
            font-weight: $medium;
            margin: 0;
          }
        }
      }
    }
  }
  .tigle {
    .product-banner {
      background-image: url("/src/assets/img/ruukki-products/tigla-metalice-si-tabla-prefaltuite/banner.jpg");
    }
  }
  .profile {
    .product-banner {
      background-image: url("/src/assets/img/ruukki-products/profile-trapezoidale-cu-cuta-mica/banner.jpg");
    }
  }
  .sisteme {
    .product-banner {
      background-image: url("/src/assets/img/ruukki-products/sistem-de-jgheaburi-si-burlane/banner.jpg");
    }
  }
  .accesorii-siguranta {
    .product-banner {
      background-image: url("/src/assets/img/ruukki-products/accesorii-pentru-siguranta-pe-acoperis/banner.jpg");
    }
  }
  .accesorii-metalice {
    .product-banner {
      background-image: url("/src/assets/img/ruukki-products/accesorii-metalice-si-folie-anticondens/banner.jpg");
    }
  }

  // RUUKKI PROFILE PRODUCTS LIST
  .profile-products-list {
    .product {
      margin-bottom: 2rem;
      border: 2px solid $dark-gray;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem;
      position: relative;
      &:last-child {
        margin: 0;
      }
      &:before {
        content: "";
        border: 2px solid $primary-color;
        border-radius: 2px;
        opacity: 0;
        position: absolute;
        top: 10px;
        right: 10px;
        bottom: 10px;
        left: 10px;
        transition: all 300ms ease-in-out;
      }
      &:hover {
        &:before {
          top: -2px;
          right: -2px;
          bottom: -2px;
          left: -2px;
          opacity: 1;
        }
        .product-details {
          li:before {
            background-color: $primary-color;
          }
        }
      }
      &-image {
        width: 130px;
      }
      &-name {
        font-size: 1rem;
        width: 320px;
        padding: 0 1rem;
      }
      &-details {
        width: calc(100% - 450px);
        li {
          color: $text-color;
          margin-bottom: 10px;
          position: relative;
          padding-left: 1rem;
          &:before {
            content: "";
            background-color: $secondary-color;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -5px;
            transition: background-color 300ms ease-in-out;
            height: 10px;
            width: 10px;
          }
        }
      }
      img {
        width: auto;
      }
      h5 {
        margin: 0;
      }
    }
  }

  // RUUKKI SISTEME
  .sisteme {
    .is-link {
      margin-bottom: 1rem;
    }
  }

  // RUUKKI ACCESORII SIGURANTA
  .accesorii-siguranta {
    .is-link {
      margin-bottom: 1rem;
    }
  }

  // RUUKKI ACCESORII METALICE
  .accesorii-metalice {
    .sageac-details__list,
    .sageac-color__list {
      li {
        border-bottom: 1px solid #eeeeee;
        padding: 10px 0 10px 1rem;
        position: relative;
        &:before {
          content: "";
          background-color: #0c9533;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -5px;
          height: 10px;
          width: 10px;
        }
      }
    }
  }
}
.page-ruukki {
  .agile {
    margin-bottom: 2rem;
  }
}

/*=============================================
=            RESPONSIVE            =
=============================================*/
@media (max-width: 991.98px) {
  .page-ruukki {
    .profile-products-list {
      .product {
        flex-wrap: wrap;
        text-align: center;
        h5 {
          margin-bottom: 2rem;
          width: 100%;
        }
        &-image {
          margin: 0 auto 1rem auto;
        }
        &-details {
          text-align: left;
          width: 100%;
        }
      }
    }
  }
  .accesorii-metalice {
    img {
      width: 100%;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/layouts/ruukkiProducts.vue